export const iconFontAwesomeMoneyNairaSign = (
	<i className="fa-solid fa-naira-sign"></i>
);
